import { ComponentProps, forwardRef } from 'react'

import { Button, Icon, buttonVariants, cn } from '@hap/components'

import Link from '../link'

export const LinkButtonReactRouter = forwardRef<
  HTMLAnchorElement,
  ComponentProps<typeof Link> & ComponentProps<typeof Button>
>(({ children, className, variant, size, icon, ...props }, ref) => {
  return (
    <Link
      {...props}
      className={cn(buttonVariants({ variant, size }), className)}
      ref={ref}
    >
      {icon && (
        <Icon
          name={icon}
          className={cn({ '-ml-1 mr-2': size !== 'icon' && size !== 'icon-sm' })}
        />
      )}
      {children}
    </Link>
  )
})
